import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "pb-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "mt-3" }, "Bulk Rules", -1)
const _hoisted_3 = {
  key: 0,
  class: "row mt-3"
}
const _hoisted_4 = { class: "col" }
const _hoisted_5 = {
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_6 = {
  key: 1,
  class: "row mt-3"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "alert alert-primary",
    role: "alert"
  }, "No Bulk Rules found")
], -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "row mt-3 py-3 border-bottom border-top bg-light" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = {
  key: 0,
  class: "alert alert-danger mt-3",
  role: "alert"
}
const _hoisted_14 = { class: "row mt-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, "Name")
], -1)
const _hoisted_16 = { class: "col-10" }
const _hoisted_17 = { class: "row mt-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, "Origin Folder")
], -1)
const _hoisted_19 = { class: "col-10" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Origin folder", -1)
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "row mt-2" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, "Destination Folder")
], -1)
const _hoisted_24 = { class: "col-10" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Destination folder", -1)
const _hoisted_26 = ["value"]
const _hoisted_27 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "offset-3 text-danger" }, [
  /*#__PURE__*/_createElementVNode("small", null, "Origin Folder and Destination Folder cannot be the same")
], -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { class: "row mt-2" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, "Rows:")
], -1)
const _hoisted_32 = { class: "col-10" }
const _hoisted_33 = ["onUpdate:modelValue"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Field", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("option", { value: "from" }, "From", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("option", { value: "to" }, "To", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("option", { value: "subject" }, "Subject", -1)
const _hoisted_38 = [
  _hoisted_34,
  _hoisted_35,
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = { class: "field custom-field custom-field_animated col-5" }
const _hoisted_40 = ["onUpdate:modelValue"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Field", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("option", { value: "from" }, "From", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("option", { value: "to" }, "To", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("option", { value: "subject" }, "Subject", -1)
const _hoisted_46 = [
  _hoisted_42,
  _hoisted_43,
  _hoisted_44,
  _hoisted_45
]
const _hoisted_47 = { class: "field custom-field custom-field_animated col-5" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = { class: "row" }
const _hoisted_50 = { class: "col-12 d-flex justify-content-end mt-3" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = ["disabled"]
const _hoisted_53 = ["disabled"]
const _hoisted_54 = { key: 1 }
const _hoisted_55 = ["disabled"]
const _hoisted_56 = ["disabled"]
const _hoisted_57 = { class: "row pt-3" }
const _hoisted_58 = { class: "col" }
const _hoisted_59 = {
  key: 0,
  class: "d-flex mt-5 justify-content-center align-items-center"
}
const _hoisted_60 = {
  key: 1,
  class: "w-100"
}
const _hoisted_61 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Move to...")
  ])
], -1)
const _hoisted_62 = ["onClick"]
const _hoisted_63 = { class: "row" }
const _hoisted_64 = { class: "col d-flex justify-content-center mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_VPagination = _resolveComponent("VPagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.error != '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.error), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.error == '' && !_ctx.loading && _ctx.bulkRules.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.selectedRule.id !== "" ? "Edit" : "Add New") + " Bulk Rule", 1),
            (
                _ctx.selectedRule.id === '' && !_ctx.validateRule() && _ctx.showFaultyFields
              )
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Please ensure all fields below are filled out and at least one row has been added "))
              : _createCommentVNode("", true)
          ]),
          (_ctx.selectedRule.id !== '')
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                style: {"cursor":"pointer"},
                title: "Stop editing",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.unselectRule()))
              }, [
                _createVNode(_component_font_awesome_icon, {
                  class: "mr-3",
                  icon: ['fas', 'times']
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(["form-control", {
                error: !_ctx.v$.selectedRule.name.required && _ctx.showFaultyFields
              }]),
              required: "",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedRule.name) = $event))
            }, null, 2), [
              [_vModelText, _ctx.selectedRule.name]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedRule.originFolderId) = $event)),
              class: _normalizeClass(["custom-select no-focus", {
                error:
                  !_ctx.v$.selectedRule.originFolderId.required && _ctx.showFaultyFields
              }]),
              required: ""
            }, [
              _hoisted_20,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.folders, (fld) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: fld.id,
                  key: fld.id
                }, _toDisplayString(fld.name), 9, _hoisted_21))
              }), 128))
            ], 2), [
              [_vModelSelect, _ctx.selectedRule.originFolderId]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedRule.destinationFolderId) = $event)),
              class: _normalizeClass(["custom-select no-focus", {
                error:
                  !_ctx.v$.selectedRule.destinationFolderId.required &&
                  _ctx.showFaultyFields
              }]),
              required: ""
            }, [
              _hoisted_25,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.folders, (fld) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: fld.id,
                  key: fld.id
                }, _toDisplayString(fld.name), 9, _hoisted_26))
              }), 128))
            ], 2), [
              [_vModelSelect, _ctx.selectedRule.destinationFolderId]
            ])
          ])
        ]),
        (!_ctx.validateFolders())
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_29))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _createElementVNode("div", _hoisted_32, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedRule.rows, (row) => {
              return (_openBlock(), _createElementBlock("div", {
                key: row.id
              }, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": ($event: any) => ((row.field) = $event),
                  class: "custom-select mt-2 mb-3 col-5",
                  required: ""
                }, _hoisted_38, 8, _hoisted_33), [
                  [_vModelSelect, row.field]
                ]),
                _createElementVNode("label", _hoisted_39, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    placeholder: "Value",
                    required: "",
                    "onUpdate:modelValue": ($event: any) => ((row.value) = $event)
                  }, null, 8, _hoisted_40), [
                    [_vModelText, row.value]
                  ])
                ]),
                _createElementVNode("a", {
                  style: {"cursor":"pointer"},
                  title: "Delete Row",
                  onClick: ($event: any) => (_ctx.deleteRow(row.id))
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    class: "text-danger mr-2",
                    icon: ['fas', 'times']
                  })
                ], 8, _hoisted_41)
              ]))
            }), 128)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newRow.field) = $event)),
              class: _normalizeClass(["custom-select mt-2 mb-3 col-5", {
                error:
                  !_ctx.v$.newRow.field.required &&
                  _ctx.selectedRule.rows.length < 1 &&
                  _ctx.showFaultyFields
              }])
            }, _hoisted_46, 2), [
              [_vModelSelect, _ctx.newRow.field]
            ]),
            _createElementVNode("label", _hoisted_47, [
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["form-control", {
                  error:
                    !_ctx.v$.newRow.value.required &&
                    _ctx.selectedRule.rows.length < 1 &&
                    _ctx.showFaultyFields
                }]),
                placeholder: "Value",
                required: "",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newRow.value) = $event))
              }, null, 2), [
                [_vModelText, _ctx.newRow.value]
              ])
            ]),
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addRow && _ctx.addRow(...args)), ["prevent"])),
              disabled: !_ctx.validateRow()
            }, " Add Row ", 8, _hoisted_48)
          ])
        ]),
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("div", _hoisted_50, [
            (_ctx.selectedRule.id === '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                  _createElementVNode("button", {
                    class: "btn btn-warning mr-1",
                    onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.addBulkRule(true)), ["prevent"])),
                    disabled: !_ctx.validateRule()
                  }, " Execute and Add ", 8, _hoisted_52),
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.addBulkRule(false)), ["prevent"])),
                    disabled: !_ctx.validateRule()
                  }, " Add Rule ", 8, _hoisted_53)
                ]))
              : _createCommentVNode("", true),
            (_ctx.selectedRule.id !== '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                  (_ctx.selectedRule.id !== '')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-danger mr-1",
                        onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.deleteBulkRule && _ctx.deleteBulkRule(...args)), ["prevent"]))
                      }, " Delete Rule "))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "btn btn-warning mr-1",
                    onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.updateBulkRule(true)), ["prevent"])),
                    disabled: !_ctx.validateRule()
                  }, " Execute and Update ", 8, _hoisted_55),
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.updateBulkRule(false)), ["prevent"])),
                    disabled: !_ctx.validateRule()
                  }, " Update Rule ", 8, _hoisted_56)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_57, [
      _createElementVNode("div", _hoisted_58, [
        (_ctx.loading && _ctx.error.length != 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
              _createVNode(_component_font_awesome_icon, {
                class: "text-primary",
                icon: ['fas', 'spinner'],
                size: "lg",
                spin: ""
              })
            ]))
          : _createCommentVNode("", true),
        (!_ctx.loading && _ctx.bulkRules.length > 0)
          ? (_openBlock(), _createElementBlock("table", _hoisted_60, [
              _hoisted_61,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bulkRules, (rl) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: rl.id,
                    class: _normalizeClass(rl.id === _ctx.selectedRule.id ? 'selected-row' : ''),
                    onClick: _withModifiers(($event: any) => (_ctx.selectedRule = { ...rl }), ["prevent"])
                  }, [
                    _createElementVNode("td", null, _toDisplayString(rl.name), 1),
                    _createElementVNode("td", null, _toDisplayString(rl.destinationFolder.name), 1)
                  ], 10, _hoisted_62))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_63, [
          _createElementVNode("div", _hoisted_64, [
            _createVNode(_component_VPagination, {
              pagination: _ctx.rulesPagination,
              "onUpdate:pagination": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.rulesPagination) = $event)),
              onPageChanged: _cache[13] || (_cache[13] = (page) => (_ctx.currentPage = page))
            }, null, 8, ["pagination"])
          ])
        ])
      ])
    ])
  ]))
}